import { createSelector } from 'reselect';

const getNotifsCounter = state => state.notifications.counter;

const makeCounterState = () =>
  createSelector([getNotifsCounter], counter => counter);

export default makeCounterState;
